const BasicSetupOptions = {
  lineNumbers: false,
  highlightActiveLineGutter: false,
  // highlightSpecialChars?: boolean;
  // history?: boolean;
  foldGutter: false
  // drawSelection?: boolean;
  // dropCursor?: boolean;
  // allowMultipleSelections?: boolean;
  // indentOnInput?: boolean;
  // syntaxHighlighting?: boolean;
  // bracketMatching?: boolean;
  // closeBrackets?: boolean;
  // autocompletion?: boolean;
  // rectangularSelection?: boolean;
  // crosshairCursor?: boolean;
  // highlightActiveLine?: boolean;
  // highlightSelectionMatches?: boolean;
  // closeBracketsKeymap?: boolean;
  // defaultKeymap?: boolean;
  // searchKeymap?: boolean;
  // historyKeymap?: boolean;
  // foldKeymap?: boolean;
  // completionKeymap?: boolean;
  // lintKeymap?: boolean;
}

export default BasicSetupOptions
